import React, { useContext, useEffect, useRef, useState } from "react";
import "./Metric.scss";
import { useTranslation, withTranslation } from "react-i18next";
import useFinalizeStatusPoller from "../../../../core/hooks/useFinalizeStatusPoller";
import {
  BiGitMerge,
  BiPlus,
  BiPencil,
  BiTrash,
  BiDotsHorizontalRounded,
  BiDownload,
  BiUpload,
  BiTransfer,
  BiGridVertical,
  BiSearch,
} from "react-icons/bi";
import { FiLink2, FiDelete } from "react-icons/fi";
import { OverlayTrigger, Dropdown, Breadcrumb, Modal } from "react-bootstrap";
import Utils from "../../../../core/utilities/Utils";
import DropdownItem from "react-bootstrap/esm/DropdownItem";
import ConfirmationModal from "../../../../components/ConfirmationModal/ConfirmationModal";
import StandardService from "../../../../core/service/StandardService";
import { useNavigate, useParams } from "react-router-dom";
import CreateMetric from "../CreateMetric/CreateMetric";
import ConfirmDialog from '../../../../core/utilities/ConfirmPopup';
import { toast } from "react-toastify";
import { SUBSCRIBER_ADMIN_TXT } from "../../../../core/constants/api";
import DataSourceLinker from "../../Datasource/DataSourceLinker";
import LinkDataSource from "../../RiskSettings/LinkDataSource/LinkDataSource";
import RiskConfigService from "../../../../core/service/RiskConfigService";
import PermissionUtils from "../../../../core/utilities/PermissisonUtils";
import EmissionManagementPanel from "./EmissionManagement/EmissionManagementPanel";
import CommonService from "../../../../core/service/CommonService";
import useHasPermission from "../../../../core/hooks/useHasPermission";
import FinalizeProgressLoader from "../../../../components/FinalizeProgressLoader/FinalizeProgressLoader";
import MoveConfigurationModal, {
  MOVE_CONFIGURATION_TYPES,
} from "../../../../components/MoveConfigurationModal/MoveConfigurationModal";
import { LoaderContext } from "../../../../App";

const Metric = ({
  t,
}) => {
  const { isFinalizeInProgress } = useFinalizeStatusPoller();
  const [metriclist, setMetricList] = useState([]);
  const [topicname, setTopicName] = useState("");
  const [addmetric, setAddMetric] = useState(false);
  const [editid, setEditId] = useState(false);
  const [show, setShow] = useState(false);
  const [deleteId, setDeleteId] = useState("");
  const [messageConfirmation, setMessageConfirmation] = useState("");
  const [confirmId, setConfirmId] = useState("");
  let lsData = JSON.parse(localStorage.getItem("authority"));
  const isSuperAdmin = PermissionUtils.isSuperAdmin(lsData.roles);
  const [data, setData] = useState([]);
  const { std_id } = useParams();
  const { topic_id } = useParams();
  const navigate = useNavigate();
  const [editMetricId, setEditMetricId] = useState(null);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [showDataSource, setShowDataSource] = useState(true);
  const [selectedMetric, setSelectedMetric] = useState(null);
  const [selectedDataSource, setSelectedDataSource] = useState(null);
  const [answeredMetricId, setAnsweredMetricId] = useState(0);

  const [showDS, setShowDS] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [unlinkConfirmType, setUnlinkConfirmType] = useState("");
  const [selectedID, setSelectedID] = useState("");
  const [draggedMetric, setDraggedMetric] = useState(null);
  const [dragOverMetricId, setDragOverMetricId] = useState(null);
  const [isDragHandleActive, setIsDragHandleActive] = useState(false);
  const [selectedMetricIds, setSelectedMetricIds] = useState([]);
  const [showMoveModal, setShowMoveModal] = useState(false);
  const [showEmissionPanel, setShowEmissionPanel] = useState(false);
  const [selectedEmissionMetric, setSelectedEmissionMetric] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const importFileRef = useRef(null);
  const { k, i18n } = useTranslation();
  const { hasConfigViewPermission, hasConfigUpdatePermission } = useHasPermission();
  const { setLoaderDisplay } = useContext(LoaderContext);
  useEffect(() => {
    getMetric(std_id, topic_id);
    setSelectedMetricIds([]);
  }, [std_id, topic_id]);

  useEffect(() => {
    const resetDragHandle = () => setIsDragHandleActive(false);
    window.addEventListener("mouseup", resetDragHandle);
    return () => window.removeEventListener("mouseup", resetDragHandle);
  }, []);

  const getMetric = (stdid, topicid) => {
    StandardService.getMetrics(stdid, topicid)
      .then((response) => {
        const metrics = [...(response.data.metrics || [])].sort(
          (a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0)
        );
        setData(metrics);
      })
      .catch((error) => { });
  };

  const deleteMetric = (id) => {
    setConfirmOpen(true);
    setDeleteId(id);
  };

  const editMetric = (id) => {
    setEditMetricId(id);
    handleShow();
  };

  const gotoDP = (m) => {
    if (m.category === 'QUALITATIVE') {
      localStorage.setItem('metricName', m.name);
      let url = '';
      if (PermissionUtils.isSuperAdmin(lsData.roles)) {
        url = '/admin/qualquestions/' + std_id + '/' + topic_id + '/' + m.id;
      } else {
        url = '/company_admin/qualquestions/' + std_id + '/' + topic_id + '/' + m.id;
      }
      navigate(url);
    } else {
      localStorage.setItem('equationData', JSON.stringify(m.equation));
      localStorage.setItem('metricName', m.name);
      let url = '';

      if (PermissionUtils.isSuperAdmin(lsData.roles)) {
        url = '/admin/datapointlist/' + std_id + '/' + topic_id + '/' + m.id;
      } else {
        url = '/company_admin/datapointlist/' + std_id + '/' + topic_id + '/' + m.id;
      }
      // if (PermissionUtils.isCompanyAdmin(lsData.roles) || PermissionUtils.isConsultant(lsData.roles)) {
      //   url = '/company_admin/datapointlist/' + std_id + '/' + topic_id + '/' + m.id;
      // } else {
      //   url = '/admin/datapointlist/' + std_id + '/' + topic_id + '/' + m.id;
      // }
      navigate(url);
    }
  };

  const breadCrumbClick = (url) => {
    let urlMain = '';
    // if (PermissionUtils.isCompanyAdmin(lsData.roles) || PermissionUtils.isConsultant(lsData.roles)) {
    //   urlMain = '/company_admin' + url
    // } else {
    //   urlMain = '/admin' + url
    // }

    if (PermissionUtils.isSuperAdmin(lsData.roles)) {
      urlMain = '/admin' + url
    } else {
      urlMain = '/company_admin' + url
    }
    navigate(urlMain);
  }

  const handleClose = () => {
    setEditMetricId(0);
    setAnsweredMetricId(0);
    setShow(false);
  };

  const handleShow = () => setShow(true);

  const handleAfterMetricSave = () => {
    setEditMetricId(0);
    setAnsweredMetricId(0);
    getMetric(std_id, topic_id);
    handleClose();
  };

  const deletConfirm = () => {
    StandardService.deleteMetric(deleteId)
      .then((response) => {
        if (response.status === 204) {
          toast.success("Success", {
            position: toast.POSITION.TOP_RIGHT,
          });
          getMetric(std_id, topic_id);
        }
      })
      .catch((error) => { });
  };

  const handleDataSourceLink = (metricId, dataSourceId = "") => {
    setSelectedMetric(metricId);
    setSelectedDataSource(dataSourceId);
    setShowDataSource(true);
  };

  const handleDataSourceUnlink = (item) => {
    RiskConfigService.unlinkDatasource(std_id, item.id, 'metric')
      .then((response) => {
        if (response.status === 200) {
          toast.success("Success", {
            position: toast.POSITION.TOP_RIGHT,
          });
          getMetric(std_id, topic_id);
        }
      })
      .catch((error) => { });
  };

  const handleDataSourceCallback = (val) => {
    setShowDataSource(false);
    getMetric(std_id, topic_id);
  };

  const getDPOrQuestionCount = (m) => {
    if (m.category === 'QUALITATIVE') {
      let count = m.question ? 1 : 0;
      count += m.question?.children?.length ?? 0;
      return count;
    } else {
      return m?.dataPointCount ? m?.dataPointCount : 0;
    }
  };

  const showConfirm = (id, confirmType) => {
    setSelectedID(id)
    setShowConfirmation(true);
    setUnlinkConfirmType(confirmType);
  }

  const confirmDelete = (val) => {
    setShowConfirmation(false);
    if (val) {
      if (unlinkConfirmType == 'ds') {
        handleDataSourceUnlink(selectedID);
      }
    }
  };

  const getTableData = (item) => {
    const updatedData = CommonService.changeFieldNameByi18n(item, i18n.language);
    return updatedData;
  }

  const openEmissionPanel = (item) => {
    setSelectedEmissionMetric(item);
    setShowEmissionPanel(true);
  };

  const closeEmissionPanel = () => {
    setShowEmissionPanel(false);
    setSelectedEmissionMetric(null);
    getMetric(std_id, topic_id);
  };

  const canReorderMetrics = () =>
    hasConfigUpdatePermission() && !isFinalizeInProgress;

  const reorderMetricsLocally = (metrics, draggedId, moveToId) => {
    const moved = metrics.find(m => m.id === draggedId);
    if (!moved) return metrics;

    const updated = metrics.filter(m => m.id !== draggedId);
    const targetIndex = updated.findIndex(m => m.id === moveToId);
    updated.splice(targetIndex + 1, 0, moved);
    return updated;
  };

  const onMetricDragHandleMouseDown = () => {
    setIsDragHandleActive(true);
  };

  const onMetricDragStart = (metric) => {
    setDraggedMetric(metric);
  };

  const onMetricDragOver = (e, metricId) => {
    e.preventDefault();
    setDragOverMetricId(metricId);
  };

  const onMetricDragEnd = () => {
    setIsDragHandleActive(false);
    if (!draggedMetric || !dragOverMetricId || draggedMetric.id === dragOverMetricId) {
      setDraggedMetric(null);
      setDragOverMetricId(null);
      return;
    }

    const reordered = reorderMetricsLocally(data, draggedMetric.id, dragOverMetricId);
    setData(reordered);

    StandardService.reorderMetric(draggedMetric.id, { movedToId: dragOverMetricId })
      .finally(() => getMetric(std_id, topic_id));

    setDraggedMetric(null);
    setDragOverMetricId(null);
  };

  const isMetricDragTarget = (item) =>
    canReorderMetrics()
    && dragOverMetricId === item.id
    && draggedMetric?.id !== item.id;

  const isMetricDragging = (item) =>
    canReorderMetrics() && draggedMetric?.id === item.id;

  const canManageMetricExportImport = () =>
    hasConfigUpdatePermission() && !isFinalizeInProgress;

  const areAllMetricsSelected = () =>
    filteredMetrics.length > 0 && filteredMetrics.every(metric => selectedMetricIds.includes(metric.id));

  const toggleMetricSelection = (metricId) => {
    setSelectedMetricIds(prev =>
      prev.includes(metricId) ? prev.filter(id => id !== metricId) : [...prev, metricId]
    );
  };

  const toggleSelectAllMetrics = () => {
    if (areAllMetricsSelected()) {
      setSelectedMetricIds(prev => prev.filter(id => !filteredMetrics.some(metric => metric.id === id)));
    } else {
      setSelectedMetricIds(prev => [...new Set([...prev, ...filteredMetrics.map(metric => metric.id)])]);
    }
  };

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  const downloadExcelFile = (response, fileName) => {
    const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const fileURL = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = fileURL;
    link.download = fileName;
    link.click();
    link.remove();
    window.URL.revokeObjectURL(fileURL);
  };

  const handleExportMetrics = () => {
    if (!std_id || !topic_id || selectedMetricIds.length === 0) return;

    StandardService.exportMetrics(std_id, topic_id, { metricIds: selectedMetricIds })
      .then((response) => {
        downloadExcelFile(response, `metrics_export_${topic_id}.xlsx`);
      })
      .catch(() => { });
  };

  const handleImportMetricsClick = () => {
    importFileRef.current?.click();
  };

  const handleImportMetricsFile = (e) => {
    const file = e.target.files?.[0];
    if (!file || !std_id || !topic_id) return;

    const formData = new FormData();
    formData.append("file", file);

    setLoaderDisplay(true);
    StandardService.importMetrics(std_id, topic_id, formData)
      .then((response) => {
        if (response.status === 200) {
          Utils.showImportResultToast(t, response.data);
          setSelectedMetricIds([]);
          getMetric(std_id, topic_id);
        }
      })
      .catch(() => { })
      .finally(() => {
        setLoaderDisplay(false);
        e.target.value = "";
      });
  };

  const searchTermLower = searchTerm.trim().toLowerCase();
  const filteredMetrics = searchTermLower
    ? data.filter((item) =>
        (item?.name || "").toLowerCase().includes(searchTermLower) ||
        (item?.code || "").toLowerCase().includes(searchTermLower)
      )
    : data;

  return (
    <>
      <div className="List_header pb-2">
        <h5 className="MH m-0">{t("Configurations.label")}</h5>
      </div>
      <div className="Topics_headeView">
        <ul>
          <li>
            Standard : <b>{localStorage.getItem('standardName')}</b>
          </li>
          <li>
            Category : <b>{localStorage.getItem('categoryName')}</b>
          </li>
          <li>
            Topic : <b>{localStorage.getItem('topicName')}</b>
          </li>
        </ul>
        {
          !showDS &&
          <div className="btn-custom p-1 text-end d-flex align-items-center justify-content-end gap-2">
            {showDataSource && (
              <div className="List_table-card_Search_Box p-0">
                <input
                  type="search"
                  className="form-control"
                  value={searchTerm}
                  onChange={handleSearch}
                  placeholder={t("SearchByNameOrCode.label")}
                  aria-label={t("SearchByNameOrCode.label")}
                />
                {/* <span className="Search_iocnBox">
                  <BiSearch />
                </span> */}
              </div>
            )}
            {canManageMetricExportImport() && (
              <>
                <OverlayTrigger overlay={Utils.renderTooltip(t("Import.label"))}>
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={handleImportMetricsClick}
                    aria-label={t("Import.label")}
                  >
                    <BiUpload className="me-1" />
                    {t("Import.label")}
                  </button>
                </OverlayTrigger>
                <input
                  ref={importFileRef}
                  type="file"
                  className="d-none"
                  accept=".xlsx,.xls"
                  onChange={handleImportMetricsFile}
                />
                {selectedMetricIds.length > 0 && (
                  <>
                    <OverlayTrigger overlay={Utils.renderTooltip(t("Export.label"))}>
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={handleExportMetrics}
                        aria-label={t("Export.label")}
                      >
                        <BiDownload className="me-1" />
                        {t("Export.label")} ({selectedMetricIds.length})
                      </button>
                    </OverlayTrigger>
                    <OverlayTrigger overlay={Utils.renderTooltip(t("Metrics.moveTo.label"))}>
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={() => setShowMoveModal(true)}
                        aria-label={t("Metrics.moveTo.label")}
                      >
                        <BiTransfer className="me-1" />
                        {t("Metrics.moveTo.label")}
                      </button>
                    </OverlayTrigger>
                  </>
                )}
              </>
            )}
            <button
              className="btn btn-secondary"
              // onClick={() => breadCrumbClick('/topiclist/' + std_id)}
              onClick={() => {
                // if (PermissionUtils.isCompanyAdmin(lsData.roles) || PermissionUtils.isConsultant(lsData.roles)) {
                //   breadCrumbClick('/standard');
                // } else {
                //   breadCrumbClick('/topiclist/' + std_id)
                // }
                if (PermissionUtils.isSuperAdmin(lsData.roles)) {
                  breadCrumbClick('/topiclist/' + std_id)
                } else {
                  breadCrumbClick('/standard');
                }
              }}
            >
              {t("Back.label")}
            </button>
          </div>
        }
      </div>
      <FinalizeProgressLoader isFinalizeInProgress={isFinalizeInProgress} />
      {
        showDataSource && filteredMetrics.length > 0 && canManageMetricExportImport() && (
          <div className="row m-0 mb-2 align-items-center metrics-select-all-row">
            <div className="col-auto p-1 d-flex align-items-center">
              <input
                className="form-check-input me-2"
                type="checkbox"
                id="select-all-metrics"
                checked={areAllMetricsSelected()}
                onChange={toggleSelectAllMetrics}
              />
              <label className="form-check-label" htmlFor="select-all-metrics">
                {t("SelectAll.label")}
              </label>
            </div>
          </div>
        )
      }
      {
        showDataSource && filteredMetrics.length > 0 && (getTableData(filteredMetrics))?.map((item) => (
          <div
            className={`card StandardAddMetric_Card${isMetricDragTarget(item) ? ' standards-drop-target' : ''}${isMetricDragging(item) ? ' opacity-50' : ''}`}
            key={item?.id}
            draggable={canReorderMetrics() && isDragHandleActive}
            onDragStart={() => onMetricDragStart(item)}
            onDragOver={(e) => canReorderMetrics() && onMetricDragOver(e, item.id)}
            onDragEnd={onMetricDragEnd}
          >
            <div className="card-body px-2 py-1">
              <div className="row m-0">
                <div
                  className="col-auto metric-drag-handle"
                  onMouseDown={() => canReorderMetrics() && onMetricDragHandleMouseDown()}
                >
                  <BiGridVertical />
                </div>
                <div className="col-lg-11 p-0 2">
                  <div className="row m-0">
                    {canManageMetricExportImport() && (
                      <div className="col-auto p-2 d-flex align-items-center">
                        <input
                          className="form-check-input m-0"
                          type="checkbox"
                          checked={selectedMetricIds.includes(item.id)}
                          onChange={() => toggleMetricSelection(item.id)}
                          onClick={(e) => e.stopPropagation()}
                        />
                      </div>
                    )}
                    <div className="col-lg-10 p-2">
                      <h6 className="mb-0 me-2">{item?.name}</h6>
                    </div>
                  </div>
                  <div className="row m-0">
                    <div className="col-auto p-2">
                      <ul className="cursor">
                        <li>
                          <h6
                            className="mb-0"
                            onClick={() => gotoDP(item)}>
                            {getDPOrQuestionCount(item)}
                          </h6>
                        </li>
                        <li>
                          <OverlayTrigger
                            placement="top"
                            overlay={Utils.renderTooltip(item.category === 'QUALITATIVE' ? t("ViewQuestions.label") : t("ViewDataPoint.label"))}
                          >
                            <span>
                              <BiGitMerge
                                onClick={() => gotoDP(item)}
                              />
                            </span>
                          </OverlayTrigger>
                        </li>
                      </ul>
                    </div>
                    <div className="col-lg-3 col-md-4 p-2">
                      <ul>
                        <li>
                          <p className="mb-0">{t("Category.label")} : </p>
                          <h6 className="mb-0">{Utils.toCamelCase(item?.category)}</h6>
                        </li>
                      </ul>
                    </div>
                    <div className="col-lg-3 col-md-3 p-2">
                      <ul>
                        <li>
                          <p className="mb-0">{t("MeasuringUnit.label")} : </p>
                          <h6 className="mb-0">{item?.unitOfMeasure}</h6>
                        </li>
                      </ul>
                    </div>
                    <div className="col-auto p-2">
                      <ul>
                        <li>
                          <p className="mb-0">{t("Code.label")} : </p>
                          <h6 className="mb-0">{item?.code}</h6>
                        </li>
                      </ul>
                    </div>
                    {
                      item.category === 'QUANTITATIVE' &&
                      <div className="col-auto p-2">
                        <div className="emission-badge-container">
                          {hasConfigUpdatePermission() && !isFinalizeInProgress && (
                            <span className={`badge emission-badge ${item.emission ? 'bg-badge-Active' : 'bg-badge-Corrected '} rounded-pill me-2`}
                              onClick={(e) => {
                                e.preventDefault();
                                openEmissionPanel(item);
                              }}>
                              {t("Emission.label")} {t(item.emission ? "Enabled.label" : "Disabled.label")}
                            </span>
                          )}
                        </div>
                      </div>
                    }
                    {
                      item.category === 'QUANTITATIVE' && item.dataPointCount === 0 &&
                      <div className="col-auto p-2">
                        <ul>
                          <DataSourceLinker item={item}
                            openDataSourceLink={(itemId, dataSourceId) => {
                              if (isFinalizeInProgress) return;
                              handleDataSourceLink(itemId, dataSourceId);
                            }}
                            unlinkDataSource={(item) => {
                              if (isFinalizeInProgress) return;
                              showConfirm(item.id, 'ds');
                            }}
                            disabled={isFinalizeInProgress} />
                        </ul>
                      </div>
                    }
                    

                    {/* <div className="col-lg-2 p-2">
                    <ul>
                      <li>
                        <p>{t("DataSource.label")}</p>
                        <h6 className="mb-0">
                          <FiLink2 className=" ms-2 cursor" />
                        </h6>
                      </li>
                    </ul>
                  </div> */}
                  </div>
                </div>
              </div>
              <div className="edit_btn-absolute">
                {
                  item?.mandatory === true ? (
                    ""
                  ) : (
                    <Dropdown hidden={!hasConfigUpdatePermission() || isFinalizeInProgress}>
                      <Dropdown.Toggle variant="blank_outline" id="dropdown-basic" disabled={isFinalizeInProgress}>
                        <BiDotsHorizontalRounded />
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        <Dropdown.Item
                          href="#"
                          onClick={() => {
                            if (isFinalizeInProgress) return;
                            editMetric(item.id);
                          }}
                          className={isFinalizeInProgress ? 'disabled-icon' : ''}
                          disabled={isFinalizeInProgress}>
                          <BiPencil /> {t("Edit.label")}
                        </Dropdown.Item>
                        <DropdownItem onClick={() => {
                          if (isFinalizeInProgress) return;
                          deleteMetric(item.id);
                        }} className={isFinalizeInProgress ? 'disabled-icon' : ''} disabled={isFinalizeInProgress}>
                          <BiTrash /> {t("Delete.label")}
                        </DropdownItem>
                      </Dropdown.Menu>
                    </Dropdown>
                  )}
              </div>
            </div>
          </div>
        ))
      }
      {
        showDataSource &&
        <div className="col-lg-12 p-1" id="idMetric">
          <button className={`btn btn-primary ${isFinalizeInProgress ? 'disabled-icon' : ''}`} hidden={!hasConfigUpdatePermission() || isFinalizeInProgress} onClick={() => {
            if (isFinalizeInProgress) return;
            setEditMetricId(null);
            handleShow()
          }} disabled={isFinalizeInProgress}>
            <BiPlus className="me-2"> </BiPlus>
            {t("Metric.label")}

          </button>
        </div>
      }

      {
        showDS &&
        <LinkDataSource
          regulation={std_id}
          paramId={selectedMetric}
          dsId={selectedDataSource}
          handleDataSourceCallback={handleDataSourceCallback}
          configType={'KPI'}
          paramType={'metric'} />
      }

      <Modal show={show} onHide={handleClose}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        dialogClassName="modal-75w"
      >
        <Modal.Header closeButton>
          < Modal.Title as="h5">

            {t(editMetricId > 0 ? (answeredMetricId > 0 ? 'AnswerMetric.label' : 'EditMetric.label') : 'AddMetric.label')}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="1">

          <CreateMetric
            stdId={std_id}
            handleDiscard={handleClose}
            topicId={topic_id}
            editMetricId={editMetricId}
            answerMode={answeredMetricId > 0}
            handleSave={handleAfterMetricSave}
            showQuestions={false}
          />
        </Modal.Body>
        {/* <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary">Understood</Button>
        </Modal.Footer> */}

      </Modal>

      <MoveConfigurationModal
        show={showMoveModal}
        onHide={() => setShowMoveModal(false)}
        moveType={MOVE_CONFIGURATION_TYPES.METRICS_TO_TOPIC}
        standardId={std_id}
        selectedIds={selectedMetricIds}
        sourceName={localStorage.getItem("topicName") || ""}
        excludeTopicId={topic_id}
        onMoveSuccess={() => {
          setSelectedMetricIds([]);
          getMetric(std_id, topic_id);
        }}
      />

      {deleteId && <ConfirmDialog
        open={confirmOpen}
        setOpen={setConfirmOpen}
        onConfirm={deletConfirm}                        >
        <div className='text-center'>{t("ConfirmDelete.label")}</div>
      </ConfirmDialog>}

      {showConfirmation && (
        <ConfirmationModal
          modalShow={true}
          messageText={t("UnlinkEmissionFactorConfirmation.label")}
          callbackModal={confirmDelete}
          confirmBtn={t("Confirm.label")}
          CancelBtn={t("Cancel.label")}
        />
      )}

      {showEmissionPanel && selectedEmissionMetric && (
        <EmissionManagementPanel
          show={showEmissionPanel}
          onHide={closeEmissionPanel}
          metric={selectedEmissionMetric}
          forSuperAdmin={isSuperAdmin}
        />
      )}
    </>
  );
};

export default withTranslation()(Metric);
